<template>
    <div class="pdf">
        <div :id="`preViewPdf${index}`"></div>
    </div>
</template>
<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
export default {
  name: 'pdfH5',
  data () {
    return {
      pdfh5:null
    }
  },
  props:['index'],
  methods: {
    openPdf (url) {
      this.pdfh5 = new Pdfh5(`#preViewPdf${this.index}`, {
        pdfurl: url,
        renderType: 'svg', // pdf渲染模式 svg canvas
        lazy: false, // 是否开启懒加载
        maxZoom: 3, // 手势缩放最大倍数 默认3
        scrollEnable: true, // 是否允许pdf滚动
        zoomEnable: true // 是否允许pdf手势缩放

      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .pdf {
      /* position: fixed;
      top: 0;
      left: 0; */
      width: 100%;
      height: 100%;
      overflow: hidden;
      z-index: 99;
    }
</style>
